'use client';

import c from 'classnames';

import { SaleType } from '@lib/types/Sale';
import { Sale } from './ProductCard';
import { ProductCardPrice } from './ProductCardPrice';
import { ProductCardSaleInfo } from './ProductCardSaleInfo';
import { useSaleState } from './useIsActiveSale';

type ProductCardPriceSectionProps = {
  price: {
    currentPrice: number;
    originalPrice: number;
    currency?: string;
    discountPercent?: number;
  };
  sale?: Sale;
  locale: string;
};

export const ProductCardPriceSection = ({
  price,
  sale,
  locale,
}: ProductCardPriceSectionProps) => {
  const { active, upcoming, type } = useSaleState(sale);

  return (
    <div data-test="search-results-price" className="mt-2 lg:mt-3">
      <div
        className={c('flex justify-between', {
          'items-center':
            (active || upcoming) && type === SaleType.FlashDealTimeBased,
          'items-start': type !== SaleType.FlashDealTimeBased,
        })}
      >
        <ProductCardPrice
          isSaleActive={active}
          isFlashDealActive={active && type === SaleType.FlashDealTimeBased}
          price={price}
          locale={locale}
        />
        {(active || upcoming) && sale ? (
          <ProductCardSaleInfo
            discountPercent={price.discountPercent ?? 0}
            sale={sale}
            isFlashDealActive={active && type === SaleType.FlashDealTimeBased}
            isFlashDealUpcoming={
              upcoming && type === SaleType.FlashDealTimeBased
            }
            locale={locale}
          />
        ) : null}
      </div>
    </div>
  );
};
